import {
  Activity,
  AppWindow,
  AppWindowMac,
  Archive,
  ArrowDown,
  ArrowDownAZ,
  ArrowDownToLine,
  ArrowDownUp,
  ArrowLeft,
  ArrowLeftRight,
  ArrowLeftToLine,
  ArrowRight,
  ArrowRightLeft,
  ArrowRightToLine,
  ArrowUp,
  ArrowUpRight,
  ArrowUpZA,
  AtSign,
  BadgeCheck,
  BadgeQuestionMark,
  Ban,
  Bed,
  Bell,
  BellOff,
  Binary,
  Book,
  BookOpenText,
  BookUser,
  Bookmark,
  Box,
  Braces,
  Brain,
  Briefcase,
  BriefcaseBusiness,
  Building,
  BuildingComplex,
  Calendar,
  Calendar1,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  Castle,
  ChartCandlestick,
  ChartColumn,
  ChartLine,
  ChartNoAxesColumn,
  ChartNoAxesCombined,
  ChartPie,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUpDown,
  Church,
  Circle,
  CircleAlert,
  CircleArrowUp,
  CircleCheck,
  CircleChevronDown,
  CircleDollarSign,
  CircleQuestionMark,
  CircleSlash,
  CircleStop,
  CircleX,
  ClipboardList,
  Clock,
  Cloud,
  CloudUpload,
  Code,
  Cog,
  Coins,
  Columns3,
  Command,
  Contact,
  Copy,
  CreditCard,
  Cuboid,
  Database,
  DatabaseBackup,
  DollarSign,
  Download,
  Droplet,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  Eye,
  EyeOff,
  Factory,
  File,
  FileInput,
  FileOutput,
  FileSearch,
  FileSpreadsheet,
  FileText,
  FileUp,
  FingerprintPattern,
  FlaskConical,
  Folder,
  FolderClock,
  FolderOpen,
  FolderPlus,
  Funnel,
  Gauge,
  Gem,
  Gift,
  GitBranch,
  Globe,
  Goal,
  Grip,
  GripVertical,
  Hand,
  HandCoins,
  Handshake,
  Hash,
  Headset,
  Hospital,
  Hourglass,
  HouseHeart,
  IdCard,
  Image,
  Inbox,
  Info,
  Italic,
  Key,
  Keyboard,
  Landmark,
  Languages,
  Layers,
  LayoutGrid,
  LayoutList,
  LetterB,
  LetterH,
  LifeBuoy,
  Lightbulb,
  LightbulbOff,
  Link,
  Link2,
  List,
  ListChecks,
  ListFilter,
  ListOrdered,
  ListTodo,
  LoaderCircle,
  Lock,
  LockKeyhole,
  LogOut,
  Mail,
  MailCheck,
  MailOpen,
  Mailbox,
  MapIcon,
  MapPin,
  MapPinHouse,
  MapPinned,
  Maximize,
  Maximize2,
  Medal,
  MessageSquare,
  MessageSquareMore,
  Mic,
  MicOff,
  Minimize2,
  Minus,
  Monitor,
  Moon,
  Network,
  Package,
  PackageOpen,
  Palette,
  PanelLeft,
  PanelRight,
  PanelTop,
  Paperclip,
  PartyPopper,
  Pause,
  Pen,
  Pencil,
  Phone,
  PhoneCall,
  PhoneOff,
  Pin,
  PinOff,
  Play,
  Plug,
  Plus,
  Presentation,
  Puzzle,
  Quote,
  Radio,
  Receipt,
  RefreshCcw,
  RefreshCw,
  Reply,
  Rocket,
  RotateCcw,
  RotateCcwClock,
  RotateCw,
  Save,
  ScanSearch,
  School,
  Search,
  Send,
  SendHorizontal,
  Settings,
  Share2,
  Sheet,
  ShieldAlert,
  ShieldCheck,
  ShieldHalf,
  ShoppingBag,
  Signature,
  Signpost,
  SlidersHorizontal,
  Smartphone,
  Sparkle,
  Sparkles,
  Sprout,
  Square,
  SquareCheck,
  SquareMinus,
  Star,
  Store,
  Sun,
  Table,
  Tag,
  Target,
  TextAlignStart,
  TextCursorInput,
  TextInitial,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Timer,
  ToggleRight,
  Trash,
  TrendingUp,
  TriangleAlert,
  Type,
  Unplug,
  Upload,
  User,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserSearch,
  UserX,
  Users,
  UsersRound,
  Wallet,
  WandSparkles,
  Warehouse,
  Webhook,
  WifiOff,
  Workflow,
  X,
  Zap,
  ZoomOut,
  createLucideIcon,
  type LucideIcon,
} from 'lucide-react';
import { CLU_COLOURS } from '@/components/ui/clu-colours';

/* Lucide dropped its brand icons, so the brands the app shows are drawn here
 * in Lucide's line style on its 24 grid. LinkedIn, Slack and GitHub are
 * Lucide's own drawings from before it dropped them. */
export const BrandGithub = createLucideIcon('brand-github', [
  [
    'path',
    {
      d: 'M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4',
      key: 'body',
    },
  ],
  ['path', { d: 'M9 18c-4.51 2-5-2-7-2', key: 'tail' }],
]);

const BrandLinkedin = createLucideIcon('brand-linkedin', [
  [
    'path',
    {
      d: 'M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z',
      key: 'n',
    },
  ],
  ['rect', { width: '4', height: '12', x: '2', y: '9', key: 'i' }],
  ['circle', { cx: '4', cy: '4', r: '2', key: 'dot' }],
]);

const BrandSlack = createLucideIcon('brand-slack', [
  ['rect', { width: '3', height: '8', x: '13', y: '2', rx: '1.5', key: 'a' }],
  ['path', { d: 'M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5', key: 'b' }],
  ['rect', { width: '3', height: '8', x: '8', y: '14', rx: '1.5', key: 'c' }],
  ['path', { d: 'M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5', key: 'd' }],
  ['rect', { width: '8', height: '3', x: '14', y: '13', rx: '1.5', key: 'e' }],
  ['path', { d: 'M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5', key: 'f' }],
  ['rect', { width: '8', height: '3', x: '2', y: '8', rx: '1.5', key: 'g' }],
  ['path', { d: 'M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5', key: 'h' }],
]);

/** Microsoft Teams: the T tile with a teammate behind it. */
const BrandTeams = createLucideIcon('brand-teams', [
  ['rect', { width: '11', height: '11', x: '2', y: '7', rx: '2', key: 'tile' }],
  ['path', { d: 'M5.5 10.5h4M7.5 10.5V15', key: 't' }],
  ['circle', { cx: '17.5', cy: '5.5', r: '2.5', key: 'head' }],
  ['path', { d: 'M13 10h7a2 2 0 0 1 2 2v3a4 4 0 0 1-4 4h-.5', key: 'body' }],
]);

/* Home, Sequences and Reports draw Clu in the mascot's own colours (as the
 * Agents icon does); the house, plane and chart lines keep the text colour. */
/** Home: a birdhouse with a round door and perch, and Clu's head (crest,
 * face, eyes and beak, traced from the mascot `CluBird`) leaning out from
 * behind its right side, clipped a little clear of the house. */
const HouseBird = createLucideIcon('house-bird', [
  [
    'path',
    {
      d: 'M2 9 8.75 2.25 15.5 9V20.5a1 1 0 0 1-1 1h-11.5a1 1 0 0 1-1-1z',
      key: 'house',
    },
  ],
  ['circle', { cx: '8.75', cy: '14.75', r: '2', key: 'door' }],
  ['path', { d: 'M8.75 19v1.25', key: 'perch' }],
  [
    'path',
    {
      d: 'M16.04 7.34L16.44 7.07L16.88 6.85L16.25 5.43L15.88 4.84L15.5 4.38L16.34 4.77L17.06 5.27L17.65 5.86L18.11 6.52L18.21 5.97L18.23 5.4L18.14 4.82L17.94 4.25L18.65 4.8L19.18 5.38L19.53 5.98L19.71 6.59L20.28 5.81L20.99 5.19L21.23 6.14L21.24 6.57L21.19 6.93L21.69 7.16L22.16 7.44L22.57 7.78L22.93 8.17L23.24 8.6L23.59 9.3L23.76 9.81L23.86 10.35L23.91 10.9L23.88 11.47L23.73 12.35L23.34 13.64L22.96 14.72L22.63 15.54L22.45 15.73L21.9 16.03L21.53 16.14L20.62 16.24L20.1 16.23L19.56 16.19L18.41 16.01L16.9 15.58L16.9 8.45L15.91 7.43ZM17.04 8.57L17.61 8.34L18.24 8.21L18.9 8.18L19.35 8.23L20.01 8.39L20.43 8.55L21.01 8.87L21.36 9.13L21.67 9.43L22.05 9.92L22.32 10.45L22.46 11L22.48 11.37L22.4 11.92L22.19 12.43L21.87 12.89L21.27 13.38L20.72 13.65L20.11 13.81L19.45 13.87L18.78 13.82L18.13 13.66L17.5 13.41L16.9 13.02L16.9 8.65Z',
      fill: CLU_COLOURS.disc,
      fillRule: 'evenodd',
      stroke: 'none',
      key: 'clu',
    },
  ],
  [
    'path',
    {
      d: 'M17.04 8.57L17.61 8.34L18.24 8.21L18.9 8.18L19.35 8.23L20.01 8.39L20.43 8.55L21.01 8.87L21.36 9.13L21.67 9.43L22.05 9.92L22.32 10.45L22.46 11L22.48 11.37L22.4 11.92L22.19 12.43L21.87 12.89L21.27 13.38L20.72 13.65L20.11 13.81L19.45 13.87L18.78 13.82L18.13 13.66L17.5 13.41L16.9 13.02L16.9 8.65Z',
      fill: '#fff',
      stroke: 'none',
      key: 'face',
    },
  ],
  [
    'circle',
    {
      cx: '17.82',
      cy: '10.54',
      r: '0.73',
      fill: CLU_COLOURS.eye,
      stroke: 'none',
      key: 'eye-a',
    },
  ],
  [
    'circle',
    {
      cx: '21.01',
      cy: '10.93',
      r: '0.73',
      fill: CLU_COLOURS.eye,
      stroke: 'none',
      key: 'eye-b',
    },
  ],
  [
    'path',
    {
      d: 'M19.05 11.19L19.57 11.18L19.98 11.32L20.32 11.58L20.45 11.8L20.48 11.95L20.4 12.41L20.08 12.85L19.54 13.21L19.07 13.38L19.14 12.12Z',
      fill: CLU_COLOURS.beak,
      stroke: 'none',
      key: 'beak',
    },
  ],
]);

/** Sequences' sidebar icon: Clu (traced from the mascot) flying off, leaning
 * forward with speed lines behind, like a message sent. The plain plane stays
 * `paper-plane-top`, which Send buttons use. */
const PaperPlaneClu = createLucideIcon('paper-plane-clu', [
  ['path', { d: 'M2.5 9.5h3.5', key: 'line-a' }],
  ['path', { d: 'M1.5 13.5h4', key: 'line-b' }],
  ['path', { d: 'M3 17.5h2.5', key: 'line-c' }],
  [
    'path',
    {
      d: 'M16.99 4.62L17.6 4.94L18.16 5.33L18.65 5.77L19.25 6.54L19.57 7.11L19.91 8.04L20.09 9.04L20.1 9.73L20.04 10.43L19.89 11.15L19.5 12.34L19.05 13.54L18.41 15L17.46 17.02L17.18 17.47L16.69 18.08L15.91 18.75L15.01 19.23L14.04 19.49L13.27 19.53L12.26 19.38L10.58 18.84L9.3 18.26L8.16 17.57L6.22 17.58L4.86 17.49L5.74 17.08L6.56 16.54L7.16 15.94L7.6 15.26L7.66 15.14L7.5 14.34L7.43 13.5L7.42 12.63L7.49 11.73L7.81 9.88L8.43 7.78L8.92 6.67L9.27 6.1L9.67 5.6L10.1 5.17L10.58 4.8L11.1 4.49L11.66 4.25L11.31 3.25L10.96 2.45L10.54 1.69L10.11 1.1L11.12 1.64L11.98 2.3L12.67 3.07L13.2 3.92L13.37 3.24L13.42 2.53L13.34 1.82L13.14 1.1L13.98 1.82L14.6 2.58L14.99 3.34L15.19 4.11L15.54 3.62L15.94 3.17L16.38 2.79L16.86 2.46L17.02 3.11L17.09 3.65L17.08 4.19ZM18.17 10.89L17.88 11.51L17.45 12.05L16.89 12.5L16.22 12.84L15.47 13.05L14.66 13.13L13.84 13.07L13.02 12.87L12.25 12.55L11.54 12.11L10.94 11.58L10.45 10.97L10.11 10.3L9.92 9.61L9.89 8.91L10.02 8.24L10.31 7.62L10.74 7.08L11.3 6.63L11.97 6.29L12.72 6.08L13.53 6.01L14.35 6.07L15.17 6.26L15.94 6.58L16.65 7.02L17.25 7.55L17.73 8.17L18.08 8.83L18.27 9.52L18.3 10.22Z',
      fill: CLU_COLOURS.disc,
      fillRule: 'evenodd',
      stroke: 'none',
      key: 'clu',
    },
  ],
  [
    'path',
    {
      d: 'M18.17 10.89L17.88 11.51L17.45 12.05L16.89 12.5L16.22 12.84L15.47 13.05L14.66 13.13L13.84 13.07L13.02 12.87L12.25 12.55L11.54 12.11L10.94 11.58L10.45 10.97L10.11 10.3L9.92 9.61L9.89 8.91L10.02 8.24L10.31 7.62L10.74 7.08L11.3 6.63L11.97 6.29L12.72 6.08L13.53 6.01L14.35 6.07L15.17 6.26L15.94 6.58L16.65 7.02L17.25 7.55L17.73 8.17L18.08 8.83L18.27 9.52L18.3 10.22Z',
      fill: '#fff',
      stroke: 'none',
      key: 'face',
    },
  ],
  [
    'circle',
    {
      cx: '12.57',
      cy: '8.88',
      r: '0.9',
      fill: CLU_COLOURS.eye,
      stroke: 'none',
      key: 'eye-a',
    },
  ],
  [
    'circle',
    {
      cx: '16.51',
      cy: '9.58',
      r: '0.9',
      fill: CLU_COLOURS.eye,
      stroke: 'none',
      key: 'eye-b',
    },
  ],
  [
    'path',
    {
      d: 'M14.07 9.77L14.37 9.74L14.7 9.79L15.21 9.99L15.61 10.33L15.76 10.62L15.78 10.81L15.77 11L15.65 11.37L15.23 11.9L14.54 12.31L13.94 12.49L14.12 10.93Z',
      fill: CLU_COLOURS.beak,
      stroke: 'none',
      key: 'beak',
    },
  ],
]);

/** Reports: a pie chart with Clu peeking out from behind it (traced like
 * Home's). */
const ChartClu = createLucideIcon('chart-clu', [
  ['circle', { cx: '7', cy: '13', r: '5.25', key: 'pie' }],
  ['path', { d: 'M7 7.75V13l4.55 2.63', key: 'slice' }],
  [
    'path',
    {
      d: 'M11.24 7.38L11.73 6.75L12.33 6.2L11.69 5.36L11.11 4.7L10.48 4.11L9.88 3.68L11.01 3.88L12.03 4.25L12.93 4.76L13.7 5.41L13.64 4.71L13.47 4.02L13.18 3.36L12.76 2.74L13.79 3.17L14.61 3.7L15.22 4.3L15.64 4.98L15.83 4.4L16.07 3.85L16.37 3.35L16.72 2.89L17.07 3.46L17.31 3.95L17.47 4.46L17.51 4.9L18.52 5.11L19.44 5.49L20.26 6.03L20.74 6.48L21.16 6.98L21.53 7.54L21.82 8.15L22.05 8.8L22.21 9.49L22.29 10.22L22.3 10.89L22.17 13.45L21.83 16.28L21.58 17.32L21.27 18.03L20.85 18.68L20.34 19.24L19.95 19.56L19.07 20.06L18.58 20.23L18.07 20.35L16.9 20.43L15.39 20.38L14.23 20.22L13.12 19.95L11.27 20.55L9.95 20.89L10.66 20.23L11.28 19.47L11.67 18.71L11.9 17.79L12.36 17.26L12.95 16.39L13.27 15.76L13.52 15.1L13.7 14.42L13.81 13.73L13.85 13.02L13.77 11.97L13.63 11.28L13.29 10.28L12.98 9.65L12.39 8.77L11.68 7.99L11.14 7.54ZM12.58 8.77L12.89 8.39L13.46 7.89L14.15 7.49L14.91 7.21L15.73 7.06L16.57 7.04L17.4 7.15L17.93 7.29L18.43 7.49L19.11 7.89L19.69 8.39L20.13 8.97L20.43 9.6L20.56 10.27L20.56 10.73L20.43 11.4L20.25 11.83L20 12.24L19.51 12.79L18.9 13.26L18.18 13.62L17.4 13.86L16.57 13.97L15.73 13.95L15.18 13.86L14.65 13.71L13.84 13.35L13.81 12.26L13.6 11.18L13.23 10.15L12.89 9.51L12.49 8.9Z',
      fill: CLU_COLOURS.disc,
      fillRule: 'evenodd',
      stroke: 'none',
      key: 'clu',
    },
  ],
  [
    'path',
    {
      d: 'M12.58 8.77L12.89 8.39L13.46 7.89L14.15 7.49L14.91 7.21L15.73 7.06L16.57 7.04L17.4 7.15L17.93 7.29L18.43 7.49L19.11 7.89L19.69 8.39L20.13 8.97L20.43 9.6L20.56 10.27L20.56 10.73L20.43 11.4L20.25 11.83L20 12.24L19.51 12.79L18.9 13.26L18.18 13.62L17.4 13.86L16.57 13.97L15.73 13.95L15.18 13.86L14.65 13.71L13.84 13.35L13.81 12.26L13.6 11.18L13.23 10.15L12.89 9.51L12.49 8.9Z',
      fill: '#fff',
      stroke: 'none',
      key: 'face',
    },
  ],
  [
    'circle',
    {
      cx: '14.63',
      cy: '10.32',
      r: '0.9',
      fill: CLU_COLOURS.eye,
      stroke: 'none',
      key: 'eye-a',
    },
  ],
  [
    'circle',
    {
      cx: '18.59',
      cy: '9.76',
      r: '0.9',
      fill: CLU_COLOURS.eye,
      stroke: 'none',
      key: 'eye-b',
    },
  ],
  [
    'path',
    {
      d: 'M16.32 10.7L16.6 10.58L16.94 10.53L17.48 10.56L17.96 10.76L18.2 10.99L18.28 11.16L18.33 11.34L18.33 11.74L18.09 12.37L17.56 12.97L17.04 13.33L16.73 11.79Z',
      fill: CLU_COLOURS.beak,
      stroke: 'none',
      key: 'beak',
    },
  ],
]);

/** X (Twitter): the X mark's band and stroke. */
const BrandX = createLucideIcon('brand-x', [
  ['path', { d: 'M4 4h4.5L20 20h-4.5z', key: 'band' }],
  ['path', { d: 'M4 20l6.5-6.5M13.5 10.5 20 4', key: 'stroke' }],
]);

/**
 * The Plain style's icons: the Lucide icon for each icon name in @/lib/icons,
 * and for the Actions drawer's own icons. Lucide has no filled icons, so a
 * solid icon draws in a heavier line.
 */
export const LUCIDE_ICONS: Record<string, LucideIcon> = {
  'address-book': BookUser,
  'address-card': Contact,
  'align-left': TextAlignStart,
  'angles-up-down': ChevronsUpDown,
  'arrow-down': ArrowDown,
  'arrow-down-arrow-up': ArrowDownUp,
  'arrow-down-a-z': ArrowDownAZ,
  'arrow-left': ArrowLeft,
  'arrow-left-from-line': ArrowLeftToLine,
  'arrow-right': ArrowRight,
  'arrow-right-from-line': ArrowRightToLine,
  'arrow-rotate-left': RotateCcw,
  'arrow-rotate-right': RotateCw,
  'arrows-left-right': ArrowLeftRight,
  'arrows-rotate': RefreshCw,
  'arrow-trend-up': TrendingUp,
  'arrow-up': ArrowUp,
  'arrow-up-right': ArrowUpRight,
  'arrow-up-right-from-square': ExternalLink,
  'arrow-up-z-a': ArrowUpZA,
  at: AtSign,
  'badge-check': BadgeCheck,
  'bag-shopping': ShoppingBag,
  ban: Ban,
  'bars-filter': ListFilter,
  bed: Bed,
  bell: Bell,
  'bell-slash': BellOff,
  binary: Binary,
  bold: LetterB,
  bolt: Zap,
  book: Book,
  bookmark: Bookmark,
  'book-open-lines': BookOpenText,
  box: Box,
  'box-archive': Archive,
  'box-isometric': Package,
  'box-open': PackageOpen,
  'brackets-curly': Braces,
  brain: Brain,
  briefcase: Briefcase,
  browser: AppWindowMac,
  building: Building,
  'building-columns': Landmark,
  buildings: BuildingComplex,
  bullseye: Target,
  'bullseye-arrow': Goal,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  'calendar-clock': CalendarClock,
  'calendar-day': Calendar1,
  'calendar-days': CalendarDays,
  'chart-bar': ChartColumn,
  'chart-line': ChartLine,
  'chart-line-up': ChartNoAxesCombined,
  'chart-simple': ChartNoAxesColumn,
  'chart-user': ChartClu,
  check: Check,
  'chess-rook': Castle,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevrons-left': ChevronsLeft,
  'chevrons-right': ChevronsRight,
  'chevron-up': ChevronUp,
  church: Church,
  circle: Circle,
  'circle-arrow-up': CircleArrowUp,
  'circle-check': CircleCheck,
  'circle-chevron-down': CircleChevronDown,
  'circle-exclamation': CircleAlert,
  'circle-info': Info,
  'circle-question': CircleQuestionMark,
  'circle-xmark': CircleX,
  'clipboard-list': ClipboardList,
  clock: Clock,
  'clock-rotate-left': RotateCcwClock,
  'cloud-arrow-up': CloudUpload,
  code: Code,
  'code-branch': GitBranch,
  coin: CircleDollarSign,
  coins: Coins,
  command: Command,
  copy: Copy,
  'credit-card': CreditCard,
  cube: Cuboid,
  database: Database,
  desktop: Monitor,
  'dollar-sign': DollarSign,
  'down-left-and-up-right-to-center': Minimize2,
  download: Download,
  'down-to-line': ArrowDownToLine,
  droplet: Droplet,
  ellipsis: Ellipsis,
  'ellipsis-vertical': EllipsisVertical,
  envelope: Mail,
  'envelope-circle-check': MailCheck,
  'envelope-open': MailOpen,
  expand: Maximize,
  eye: Eye,
  'eye-slash': EyeOff,
  file: File,
  'file-arrow-up': FileUp,
  'file-csv': FileSpreadsheet,
  'file-export': FileOutput,
  'file-lines': FileText,
  'file-magnifying-glass': FileSearch,
  'file-spreadsheet': Sheet,
  filter: Funnel,
  fingerprint: FingerprintPattern,
  flask: FlaskConical,
  'floppy-disk': Save,
  folder: Folder,
  'folder-open': FolderOpen,
  'folder-plus': FolderPlus,
  gauge: Gauge,
  gear: Settings,
  gem: Gem,
  gift: Gift,
  globe: Globe,
  'grid-2': LayoutGrid,
  'grip-vertical': GripVertical,
  hand: Hand,
  handshake: Handshake,
  hashtag: Hash,
  heading: LetterH,
  headset: Headset,
  hospital: Hospital,
  house: HouseBird,
  'house-user': HouseHeart,
  'id-card': IdCard,
  image: Image,
  inbox: Inbox,
  industry: Factory,
  italic: Italic,
  key: Key,
  keyboard: Keyboard,
  language: Languages,
  'layer-group': Layers,
  'life-ring': LifeBuoy,
  lightbulb: Lightbulb,
  'lightbulb-slash': LightbulbOff,
  link: Link,
  list: List,
  'list-bullets': ListTodo,
  'list-check': ListChecks,
  'list-ol': ListOrdered,
  'list-ul': List,
  'location-dot': MapPin,
  lock: Lock,
  'lock-keyhole': LockKeyhole,
  'magnifying-glass': Search,
  'magnifying-glass-chart': ScanSearch,
  'magnifying-glass-minus': ZoomOut,
  mailbox: Mailbox,
  medal: Medal,
  message: MessageSquare,
  'message-dots': MessageSquareMore,
  minus: Minus,
  'mobile-screen-button': Smartphone,
  moon: Moon,
  palette: Palette,
  paperclip: Paperclip,
  'paper-plane': Send,
  'paper-plane-top': SendHorizontal,
  'paper-plane-clu': PaperPlaneClu,
  'party-horn': PartyPopper,
  pause: Pause,
  pen: Pen,
  pencil: Pencil,
  phone: Phone,
  'phone-hangup': PhoneOff,
  microphone: Mic,
  'microphone-slash': MicOff,
  dialpad: Grip,
  'phone-volume': PhoneCall,
  play: Play,
  plug: Plug,
  'plug-circle-xmark': Unplug,
  plus: Plus,
  'presentation-screen': Presentation,
  'puzzle-piece': Puzzle,
  question: BadgeQuestionMark,
  'quote-left': Quote,
  receipt: Receipt,
  'rectangle-list': LayoutList,
  reply: Reply,
  'right-from-bracket': LogOut,
  rocket: Rocket,
  'rocket-launch': Rocket,
  rotate: RefreshCcw,
  'sack-dollar': HandCoins,
  school: School,
  seedling: Sprout,
  'share-nodes': Share2,
  'shield-check': ShieldCheck,
  'shield-exclamation': ShieldAlert,
  'shield-halved': ShieldHalf,
  sidebar: PanelLeft,
  'sidebar-flip': PanelRight,
  'signal-stream': Radio,
  signature: Signature,
  sitemap: Network,
  sliders: SlidersHorizontal,
  sparkles: Sparkles,
  'spinner-third': LoaderCircle,
  square: Square,
  'square-check': SquareCheck,
  star: Star,
  'star-solid': Star,
  stars: Sparkle,
  stop: CircleStop,
  stopwatch: Timer,
  store: Store,
  sun: Sun,
  t: Type,
  table: Table,
  'table-columns': Columns3,
  tag: Tag,
  text: TextInitial,
  'thumbs-down': ThumbsDown,
  'thumbs-up': ThumbsUp,
  thumbtack: Pin,
  'thumbtack-slash': PinOff,
  ticket: Ticket,
  'toggle-on': ToggleRight,
  trash: Trash,
  'triangle-exclamation': TriangleAlert,
  upload: Upload,
  'up-right-and-down-left-from-center': Maximize2,
  user: User,
  'user-check': UserCheck,
  'user-gear': UserCog,
  'user-group': UsersRound,
  'user-magnifying-glass': UserSearch,
  'user-minus': UserMinus,
  'user-plus': UserPlus,
  users: Users,
  'user-slash': UserX,
  wallet: Wallet,
  'wand-magic-sparkles': WandSparkles,
  warehouse: Warehouse,
  'wave-pulse': Activity,
  webhook: Webhook,
  'window-restore': AppWindow,
  xmark: X,
  linkedin: BrandLinkedin,
  slack: BrandSlack,
  teams: BrandTeams,
  'x-twitter': BrandX,
  'wifi-slash': WifiOff,
  'csv-logo': FileSpreadsheet,
  'import-crm': DatabaseBackup,
  'import-csv': FileInput,
  'manual-entry': TextCursorInput,
  'crm-contact-lookup': UserSearch,
  'export-csv': FileOutput,
  'sync-crm': RefreshCw,
  'headline-card': PanelTop,
  'summary-doc': FileText,
  'x-handle': BrandX,
  hourglass: Hourglass,
  'study-book': BookOpenText,
  connections: Network,
  'company-linkedin': Link2,
  'naics-code': Hash,
  'stock-candles': ChartCandlestick,
  'past-company': FolderClock,
  'past-title': BriefcaseBusiness,
  'past-seniority': Medal,
  'past-department': Workflow,
  'hq-region': MapPinned,
  'title-ban': CircleSlash,
  'company-ban': Ban,
  'headcount-growth': TrendingUp,
  'box-check': SquareCheck,
  'box-minus': SquareMinus,
  'salesforce-cloud': Cloud,
  'hubspot-sprocket': Cog,
  'spark-plain': Sparkle,
  'team-size': Users,
  investor: HandCoins,
  // Filter rows that shared a glyph with a neighbour, or drew Clu in Plain.
  city: MapPinHouse,
  'state-province': MapIcon,
  'hq-location': Landmark,
  'hq-city': Signpost,
  revenue: CircleDollarSign,
  'job-change': ArrowRightLeft,
  'profile-refreshed': RefreshCw,
  'team-mix': ChartPie,
};
